import React, { useState } from 'react';
import './index.css';

const UpgradeSubscription = (props) => {
    const { cancel, currentSubscription, subscriptionName } = props;
    const [selectedPlan, setSelectedPlan] = useState(null);

    const handlePlanSelection = (plan) => {
        if (selectedPlan == plan) {
            setSelectedPlan(null);
        }
        else {
            setSelectedPlan(plan);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Selected Plan:', selectedPlan);
        // Add logic to handle form submission
    };


    return (
        <div className="confirm-removal-container-two">
            <div className="upgrade-box-container">
                <p onClick={cancel} className="close-icon-update">x</p>



                <div className="upgrade-container">

                    <h3 className='main-header-style'>Upgrade Subscrition</h3>


                    <div className={`upgrade-item-container ${selectedPlan === 'pro' || currentSubscription == 4 || currentSubscription == 36 ? (selectedPlan === 'pro' && (currentSubscription != 4 && currentSubscription != 36)) ? 'selected' : 'upgraded' : ''} `}
                        style={{ backgroundColor: currentSubscription <= 36 ? '#3c3c3c' : '#4d4d4d' }}
                        onClick={() => handlePlanSelection('pro')}
                    >
                        <div className="child-container-style">
                            <div className="header-style fc-white ">Pro</div>
                            <div className="">
                                <input
                                    type="radio"
                                    id="pro"
                                    name="planSelected"
                                    className={currentSubscription <= 36 ? "d-none" : ''}
                                    value="pro"
                                    checked={selectedPlan === 'pro'}
                                />

                                {currentSubscription <= 36 && <div className='radio-button'>
                                    <img className='image-style' src={require('../../../../../asset/checkedImage.png')} alt="Checked Icon" />
                                </div>}


                            </div>
                        </div>

                        <div className="child-container-style-two">
                            <p className="price-value-style fc-white">$39.99/yr USD</p>
                            <p className="fc-grey">- Nationwide land ownership maps</p>
                            <p className="fc-grey">- Basic Hunt Planner filters & data</p>
                        </div>
                    </div>


                    <div className={`upgrade-item-container ${selectedPlan === 'pro-advantage' || currentSubscription == 36 ? (selectedPlan === 'pro-advantage' && currentSubscription != 36) ? 'selected' : 'upgraded' : ''}`}

                        style={{ backgroundColor: currentSubscription == 36 ? '#3c3c3c' : '#4d4d4d' }}
                        onClick={() => handlePlanSelection('pro-advantage')}
                    >
                        <div className="child-container-style">
                            <div className="header-style fc-white">Pro Advantage</div>
                            <div className="">
                                <input
                                    type="radio"
                                    id="pro-advantage"
                                    name="planSelected"
                                    className={currentSubscription == 36 ? "d-none" : ''}
                                    value="pro-advantage"
                                    checked={selectedPlan === 'pro-advantage'}

                                />

                                {currentSubscription == 36 && <div className='radio-button'>
                                    <img className='image-style' src={require('../../../../../asset/checkedImage.png')} alt="Checked Icon" />
                                </div>}
                            </div>
                        </div>

                        <div className="child-container-style-two">
                            <p className="price-value-style fc-white">$69.99/yr USD</p>
                            <p className="fc-grey">- Nationwide land ownership maps</p>
                            <p className="fc-grey">- Basic Hunt Planner filters & data</p>
                            <p className="fc-grey">- Field Rescue by GLOBAL RESCUE</p>
                        </div>
                    </div>


                    <div className={`upgrade-item-container ${selectedPlan === 'pro-ultimate' ? 'selected' : ''}`}
                        style={{ backgroundColor: '#4d4d4d' }}
                        onClick={() => handlePlanSelection('pro-ultimate')}
                    >

                        <div className="child-container-style">
                            <div className="header-style fc-white">Pro Ultimate</div>
                            <div className="">
                                <input
                                    type="radio"
                                    id="pro-ultimate"
                                    name="planSelected"
                                    // className={`d-none`}
                                    value="pro-ultimate"
                                    checked={selectedPlan === "pro-ultimate"}
                                />
                                {/* {<div className='radio-button'>
                                    <img className='image-style' src={require('../../../../../asset/checkedImage.png')} alt="Checked Icon" />
                                </div>} */}
                            </div>
                        </div>
                        <div className="child-container-style-two">
                            <p className="price-value-style fc-white">$99.99/yr USD</p>
                            <p className="fc-grey">- Nationwide land ownership maps</p>
                            <p className="fc-grey"><span className="fc-green t-bold">- Premium HUNT PLANNER</span> filters & data</p>
                            <p className="fc-grey">- Field Rescue by GLOBAL RESCUE</p>
                        </div>
                    </div>

                    <button className='upgrade-button-style'>Upgrade Subscrition</button>

                </div>



                {/* <div className="alert-center">
                    <div className="p-purchase-plan scroll-bar-640">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div
                                    className={`bg-grey pt-1 h-100 pro br-10 ${selectedPlan === 'pro' ? 'selected' : ''}`}
                                    onClick={() => handlePlanSelection('pro')}
                                >
                                    <div className="h-80 ml-4">
                                        <div className="row">
                                            <div className="col fs-4 fw-bold">Pro</div>
                                            <div className="col-auto">
                                                <input
                                                    type="radio"
                                                    id="pro"
                                                    name="planSelected"
                                                    className="d-none"
                                                    value="pro"
                                                    checked={selectedPlan === 'pro'}
                                                    onChange={() => handlePlanSelection('pro')}
                                                />
                                            </div>
                                        </div>
                                        <p className="fw-normal fs-6 mb-0">$39.99/yr USD</p>
                                        <div className="plan-details">
                                            <ul className="dashed">
                                                <li className="landing-text">Nationwide land ownership maps</li>
                                                <li className="landing-text">Basic Hunt Planner filters & data</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row pt-4">
                                <div
                                    className={`bg-grey pt-1 h-90 pro-advantage br-10 ${selectedPlan === 'pro-advantage' ? 'selected' : ''}`}
                                    onClick={() => handlePlanSelection('pro-advantage')}
                                >
                                    <div className="h-80 ml-4">
                                        <div className="row">
                                            <div className="col fs-4 fw-bold">Pro Advantage</div>
                                            <div className="col-auto">
                                                <input
                                                    type="radio"
                                                    id="pro-advantage"
                                                    name="planSelected"
                                                    className="d-none"
                                                    value="pro-advantage"
                                                    checked={selectedPlan === 'pro-advantage'}
                                                    onChange={() => handlePlanSelection('pro-advantage')}
                                                />
                                            </div>
                                        </div>
                                        <p className="fw-normal fs-6 mb-0">$69.99/yr USD</p>
                                        <div className="plan-details">
                                            <ul className="dashed">
                                                <li className="landing-text">Nationwide land ownership maps</li>
                                                <li className="landing-text">Basic Hunt Planner filters & data</li>
                                                <li className="landing-text">Field Rescue by GLOBAL RESCUE</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row pt-4">
                                <div
                                    className={`bg-grey pt-1 h-90 pro-ultimate br-10 ${selectedPlan === 'pro-ultimate' ? 'selected' : ''}`}
                                    onClick={() => handlePlanSelection('pro-ultimate')}
                                >
                                    <div className="h-80">
                                        <div className="row">
                                            <div className="col fw-bold fs-4">Pro Ultimate</div>
                                            <div className="col-auto">
                                                <input
                                                    type="radio"
                                                    id="pro-ultimate"
                                                    name="planSelected"
                                                    className="d-none"
                                                    value="pro-ultimate"
                                                    checked={selectedPlan === 'pro-ultimate'}
                                                    onChange={() => handlePlanSelection('pro-ultimate')}
                                                />
                                            </div>
                                        </div>
                                        <p className="fw-normal fs-6 mb-0">$99.99/yr USD</p>
                                        <div className="plan-details">
                                            <ul className="dashed">
                                                <li className="landing-text">Nationwide land ownership maps</li>
                                                <li className="landing-text"><span className="fc-green t-bold">Premium HUNT PLANNER</span> filters & data</li>
                                                <li className="landing-text">Field Rescue by GLOBAL RESCUE</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row terms pt-3">
                                <div className="text-center">
                                    <a href="#" className="a-13">Terms</a>
                                </div>
                                <div className="text-center">
                                    Plan automatically renews. Cancel anytime.
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-3"></div>
                                <div className="col-md-6">
                                    <button type="submit" className="btn btn-next">Next</button>
                                </div>
                                <div className="col-md-3"></div>
                            </div>
                        </form>
                    </div>
                </div> */}
            </div>
        </div >
    );
};

export default UpgradeSubscription;
